import {
    GET_FILTER_TRANSACTION_FAILD, GET_FILTER_TRANSACTION_SUCCESS, GET_FILTER_TRANSACTION_LOADING, GET_FILTER_TRANSACTION_RESET
} from "../types";

const initialState = {
    loading: false,
    error: null,
    transactionListDetails: null,
    status : null 
};

export const transactionsFilterReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any , status :any }
) => {
    switch (action.type) {
        case GET_FILTER_TRANSACTION_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_FILTER_TRANSACTION_SUCCESS:
            return {
                loading: false,
                transactionListDetails: action.payload,
                status : action.status ,
                error: null,
            };
        case GET_FILTER_TRANSACTION_FAILD:
            return {
                ...state,
                loading: false,
                transactionListDetails: null,
                status: action.status , 
                error: action.error,
            };
        case GET_FILTER_TRANSACTION_RESET:
            return initialState;
        default:
            return state;
    }
};
